import assign from 'object-assign';
import * as types from '../actions/ActionTypes';
import InitialState from './InitialState';

export default function regionReducer(
    state: any = InitialState.regionsResult,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.LOAD_REGIONS_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }

        case types.CREATE_REGION_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;
        }

        case types.EDIT_REGION_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            newState.edit = assign({}, action.result);
            return newState;
        }

        case types.UPDATE_REGION_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;
        }

        case types.DELETE_REGION_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list.filter((x: any) => x.id !== action.result.id)];
            return newState;
        }

        default:
            return state;
    }
}
